// src/pages/About/About.jsx
import React from 'react';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';

export const About = () => {
  const breadcrumbs = [{ label: 'О нас', path: '/about' }];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />
        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '16px',
        }}>
          О нас
        </h1>
        <p style={{ fontSize: '16px', color: 'rgb(var(--c-text-secondary))', lineHeight: 1.8 }}>
          {/* Бренд владельца: «Студия Рекламы» (2026-10-07). Было «НОРРАН» */}
          Студия Рекламы — рекламное агентство полного цикла. Мы создаем
          рекламу, которая приносит продажи. Наш подход — комплексное решение
          задач клиента от стратегии до реализации.
        </p>
      </div>
    </div>
  );
};